import { render } from "./NavigationMobileBody.vue?vue&type=template&id=5acc83d4"
import script from "./NavigationMobileBody.vue?vue&type=script&lang=js"
export * from "./NavigationMobileBody.vue?vue&type=script&lang=js"

import "./NavigationMobileBody.vue?vue&type=style&index=0&id=5acc83d4&lang=scss"

import exportComponent from "C:\\Users\\chervinskii_mk\\Documents\\ORIS\\Repositories\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__